import { Action } from 'redux';
import { EVALUATION_RESET } from 'src/modules/evaluation/actions/EvaluationActions';
import { EvaluationState } from 'src/modules/evaluation/types/EvaluationState';

export function evaluationDataReducer(state: EvaluationState, action: Action): EvaluationState {
  if (EVALUATION_RESET.is(action)) {
    return {
      generatedProposal: null,
    };
  }

  return state;
}
